import script from "./MProfileProfessionalLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./MProfileProfessionalLinks.vue?vue&type=script&setup=true&lang=js"

import "./MProfileProfessionalLinks.vue?vue&type=style&index=0&id=6ee9f64d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ee9f64d"]])

export default __exports__